import { render } from "./registers.vue?vue&type=template&id=77b8ad62"
import script from "./registers.vue?vue&type=script&lang=js"
export * from "./registers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__